var Dinero = require('dinero.js')

/**
 * La gestione del require da parte di webpack differisce da quella di node.
 * Quando si lanciano i test il require viene risolto da node. Dinero è di tipo DineroFactory, quindi possiamo utilizzarlo direttamente.
 * Quando si crea il bundle, webpack risolve il require ritornando un oggetto che alla chiave default contiene DineroFactory.
 * Questo if dunque garantisce il funzionamento del bundle senza interferire con node in fase di test.
 */
if(Dinero.default) {
    Dinero = Dinero.default;
}


/**
* @typedef {'HALF_ODD' | 'HALF_EVEN' | 'HALF_UP' | 'HALF_DOWN' | 'HALF_TOWARDS_ZERO' | 'HALF_AWAY_FROM_ZERO'} RoundingType
*/

/**
* @typedef {"AED"|"AFN"|"ALL"|"AMD"|"ANG"|"AOA"|"ARS"|"AUD"|"AWG"|"AZN"|"BAM"|"BBD"|"BDT"|"BGN"|"BHD"|"BIF"|"BMD"|"BND"|"BOB"|"BOV"|"BRL"|"BSD"|"BTN"|"BWP"|"BYN"|"BZD"|"CAD"|"CDF"|"CHE"|"CHF"|"CHW"|"CLF"|"CLP"|"CNY"|"COP"|"COU"|"CRC"|"CUC"|"CUP"|"CVE"|"CZK"|"DJF"|"DKK"|"DOP"|"DZD"|"EGP"|"ERN"|"ETB"|"EUR"|"FJD"|"FKP"|"GBP"|"GEL"|"GHS"|"GIP"|"GMD"|"GNF"|"GTQ"|"GYD"|"HKD"|"HNL"|"HRK"|"HTG"|"HUF"|"IDR"|"ILS"|"INR"|"IQD"|"IRR"|"ISK"|"JMD"|"JOD"|"JPY"|"KES"|"KGS"|"KHR"|"KMF"|"KPW"|"KRW"|"KWD"|"KYD"|"KZT"|"LAK"|"LBP"|"LKR"|"LRD"|"LSL"|"LYD"|"MAD"|"MDL"|"MGA"|"MKD"|"MMK"|"MNT"|"MOP"|"MRU[13]"|"MUR"|"MVR"|"MWK"|"MXN"|"MXV"|"MYR"|"MZN"|"NAD"|"NGN"|"NIO"|"NOK"|"NPR"|"NZD"|"OMR"|"PAB"|"PEN"|"PGK"|"PHP"|"PKR"|"PLN"|"PYG"|"QAR"|"RON"|"RSD"|"RUB"|"RWF"|"SAR"|"SBD"|"SCR"|"SDG"|"SEK"|"SGD"|"SHP"|"SLL"|"SOS"|"SRD"|"SSP"|"STN[15]"|"SVC"|"SYP"|"SZL"|"THB"|"TJS"|"TMT"|"TND"|"TOP"|"TRY"|"TTD"|"TWD"|"TZS"|"UAH"|"UGX"|"USD"|"USN"|"UYI"|"UYU"|"UYW"|"UZS"|"VES"|"VND"|"VUV"|"WST"|"XAF"|"XAG"|"XAU"|"XBA"|"XBB"|"XBC"|"XBD"|"XCD"|"XDR"|"XOF"|"XPD"|"XPF"|"XPT"|"XSU"|"XTS"|"XUA"|"XXX"|"YER"|"ZAR"|"ZMW"|"ZWL"} ISOCurrencies 
*/

/**
* @typedef {{"AED":"United Arab Emirates dirham","AFN":"Afghan afghani","ALL":"Albanian lek","AMD":"Armenian dram","ANG":"Netherlands Antillean guilder","AOA":"Angolan kwanza","ARS":"Argentine peso","AUD":"Australian dollar","AWG":"Aruban florin","AZN":"Azerbaijani manat","BAM":"Bosnia and Herzegovina convertible mark","BBD":"Barbados dollar","BDT":"Bangladeshi taka","BGN":"Bulgarian lev","BHD":"Bahraini dinar","BIF":"Burundian franc","BMD":"Bermudian dollar","BND":"Brunei dollar","BOB":"Boliviano","BOV":"Bolivian Mvdol (funds code)","BRL":"Brazilian real","BSD":"Bahamian dollar","BTN":"Bhutanese ngultrum","BWP":"Botswana pula","BYN":"Belarusian ruble","BZD":"Belize dollar","CAD":"Canadian dollar","CDF":"Congolese franc","CHE":"WIR Euro (complementary currency)","CHF":"Swiss franc","CHW":"WIR Franc (complementary currency)","CLF":"Unidad de Fomento (funds code)","CLP":"Chilean peso","CNY":"Renminbi (Chinese) yuan[8]","COP":"Colombian peso","COU":"Unidad de Valor Real (UVR) (funds code)[9]","CRC":"Costa Rican colon","CUC":"Cuban convertible peso","CUP":"Cuban peso","CVE":"Cape Verdean escudo","CZK":"Czech koruna","DJF":"Djiboutian franc","DKK":"Danish krone","DOP":"Dominican peso","DZD":"Algerian dinar","EGP":"Egyptian pound","ERN":"Eritrean nakfa","ETB":"Ethiopian birr","EUR":"Euro","FJD":"Fiji dollar","FKP":"Falkland Islands pound","GBP":"Pound sterling","GEL":"Georgian lari","GHS":"Ghanaian cedi","GIP":"Gibraltar pound","GMD":"Gambian dalasi","GNF":"Guinean franc","GTQ":"Guatemalan quetzal","GYD":"Guyanese dollar","HKD":"Hong Kong dollar","HNL":"Honduran lempira","HRK":"Croatian kuna","HTG":"Haitian gourde","HUF":"Hungarian forint","IDR":"Indonesian rupiah","ILS":"Israeli new shekel","INR":"Indian rupee","IQD":"Iraqi dinar","IRR":"Iranian rial","ISK":"Icelandic króna","JMD":"Jamaican dollar","JOD":"Jordanian dinar","JPY":"Japanese yen","KES":"Kenyan shilling","KGS":"Kyrgyzstani som","KHR":"Cambodian riel","KMF":"Comoro franc","KPW":"North Korean won","KRW":"South Korean won","KWD":"Kuwaiti dinar","KYD":"Cayman Islands dollar","KZT":"Kazakhstani tenge","LAK":"Lao kip","LBP":"Lebanese pound","LKR":"Sri Lankan rupee","LRD":"Liberian dollar","LSL":"Lesotho loti","LYD":"Libyan dinar","MAD":"Moroccan dirham","MDL":"Moldovan leu","MGA":"Malagasy ariary","MKD":"Macedonian denar","MMK":"Myanmar kyat","MNT":"Mongolian tögrög","MOP":"Macanese pataca","MRU[13]":"Mauritanian ouguiya","MUR":"Mauritian rupee","MVR":"Maldivian rufiyaa","MWK":"Malawian kwacha","MXN":"Mexican peso","MXV":"Mexican Unidad de Inversion (UDI) (funds code)","MYR":"Malaysian ringgit","MZN":"Mozambican metical","NAD":"Namibian dollar","NGN":"Nigerian naira","NIO":"Nicaraguan córdoba","NOK":"Norwegian krone","NPR":"Nepalese rupee","NZD":"New Zealand dollar","OMR":"Omani rial","PAB":"Panamanian balboa","PEN":"Peruvian sol","PGK":"Papua New Guinean kina","PHP":"Philippine peso[14]","PKR":"Pakistani rupee","PLN":"Polish złoty","PYG":"Paraguayan guaraní","QAR":"Qatari riyal","RON":"Romanian leu","RSD":"Serbian dinar","RUB":"Russian ruble","RWF":"Rwandan franc","SAR":"Saudi riyal","SBD":"Solomon Islands dollar","SCR":"Seychelles rupee","SDG":"Sudanese pound","SEK":"Swedish krona/kronor","SGD":"Singapore dollar","SHP":"Saint Helena pound","SLL":"Sierra Leonean leone","SOS":"Somali shilling","SRD":"Surinamese dollar","SSP":"South Sudanese pound","STN[15]":"São Tomé and Príncipe dobra","SVC":"Salvadoran colón","SYP":"Syrian pound","SZL":"Swazi lilangeni","THB":"Thai baht","TJS":"Tajikistani somoni","TMT":"Turkmenistan manat","TND":"Tunisian dinar","TOP":"Tongan paʻanga","TRY":"Turkish lira","TTD":"Trinidad and Tobago dollar","TWD":"New Taiwan dollar","TZS":"Tanzanian shilling","UAH":"Ukrainian hryvnia","UGX":"Ugandan shilling","USD":"United States dollar","USN":"United States dollar (next day) (funds code)","UYI":"Uruguay Peso en Unidades Indexadas (URUIURUI) (funds code)","UYU":"Uruguayan peso","UYW":"Unidad previsional[16]","UZS":"Uzbekistan som","VES":"Venezuelan bolívar soberano[14]","VND":"Vietnamese đồng","VUV":"Vanuatu vatu","WST":"Samoan tala","XAF":"CFA franc BEAC","XAG":"Silver (one troy ounce)","XAU":"Gold (one troy ounce)","XBA":"European Composite Unit (EURCO) (bond market unit)","XBB":"European Monetary Unit (E.M.U.-6) (bond market unit)","XBC":"European Unit of Account 9 (E.U.A.-9) (bond market unit)","XBD":"European Unit of Account 17 (E.U.A.-17) (bond market unit)","XCD":"East Caribbean dollar","XDR":"Special drawing rights","XOF":"CFA franc BCEAO","XPD":"Palladium (one troy ounce)","XPF":"CFP franc (franc Pacifique)","XPT":"Platinum (one troy ounce)","XSU":"SUCRE","XTS":"Code reserved for testing","XUA":"ADB Unit of Account","XXX":"No currency ","YER":"Yemeni rial","ZAR":"South African rand","ZMW":"Zambian kwacha","ZWL":"Zimbabwean dollar"}} Currencies - formato ISO 4217 (https://en.wikipedia.org/wiki/ISO_4217#Active_codes) es 'EUR'
*/

/**
 * 
 * @typedef {Object} ValorePerValuta
 * @property {string} [roundingtype="HALF_UP"]
 * @property {number} [precisionexpected=8]
 * @property {string} [currency="EUR"]
 * @property {number} valore 
 */

 /**
 * 
 * @typedef {ValorePerValuta & {aliquota: number, pivato: boolean}} ValorePerValutaConAliquota
 * @property {number} aliquota 
 * @property {boolean} [pivato=false]
 */

/**
 * 
 * @typedef {Object} ImponibileIvato 
 * @property {Dinero.Dinero} imponibiledin
 * @property {Dinero.Dinero} ivatodin
 * @property {Dinero.Dinero} impostadin
 * @property {number} imponibile
 * @property {number} ivato
 * @property {number} imposta
 */

/**
 * Dinero lavora solo su interi
 * 
 * @param {ValorePerValuta} param 
 * @returns {Dinero.Dinero}
 */
function valuefordinero(param) { 
    
    if(typeof param.roundingtype === 'undefined') param.roundingtype = "HALF_UP";
    if(typeof param.precisionexpected === 'undefined') param.precisionexpected = 8;
    if(typeof param.currency === 'undefined') param.currency = "EUR";
    
    if(isNaN(param.valore)){
        //console.log("non ho ricevuto un valore numerico", typeof param.valore)
        return param.valore.convertPrecision(param.precisionexpected, param.roundingtype);
    } else {
        var valorestr = "" + param.valore;
        var possep = valorestr.indexOf(".");
        var precision = possep === -1 ? 0 : valorestr.length - possep - 1;
        var tenpow = Math.pow(10, precision);
        var valoreint = Number(valorestr.replace(".", "")); //param.valore * tenpow; //introduce errore
        var dineropar = {amount: valoreint || 0, precision: precision, currency: param.currency};
        var valoreindinero = Dinero(dineropar);
        valoreindinero = valoreindinero.convertPrecision(param.precisionexpected, param.roundingtype);
    
        return valoreindinero; 
    }
}

/**
 * 
 * @param {Dinero.Dinero} val 
 * @param {number} aliquota 
 * @returns {Dinero.Dinero}
 */
function scorporaIVA(val, aliquota){
  return val.multiply(100/(100+aliquota))
}

/**
 * 
 * @param {Dinero.Dinero} val 
 * @param {number} aliquota
 * @returns {Dinero.Dinero} 
 */
function aggiungiIVA(val, aliquota){  
  return val.multiply((100+aliquota)/100)
}

/**
 * @deprecated
 */
function imponibileivatoDEPRECATED(param){
    if(typeof param.roundingtype === 'undefined') param.roundingtype = "HALF_UP";
    if(typeof param.precisionexpected === 'undefined') param.precisionexpected = 2;
    if(typeof param.currency === 'undefined') param.currency = "EUR";
    if(typeof param.pivato === 'undefined') param.pivato = false;
  
    var valorenorm = valuefordinero(param);
    var ivato = 0;
    var imponibile = 0;
    
    if(param.pivato){
      ivato = valorenorm;
      imponibile = scorporaIVA(valorenorm, param.aliquota); //valorenorm.multiply(100/(100+param.aliquota))
    } else {
      imponibile = valorenorm;
      ivato = aggiungiIVA(valorenorm, param.aliquota) //valorenorm.multiply((100+param.aliquota)/100)
    }
    var imposta = imponibile.percentage(param.aliquota);
    var impostadin = valuefordinero({valore: imposta, precisionexpected: param.precisionexpected, currency: param.currency, roundingtype: param.roundingtype})

    return {
      imponibiledin: imponibile,
      ivatodin: ivato,
      impostadin: impostadin,
      imponibile: imponibile.toRoundedUnit(param.precisionexpected, param.roundingtype),
      ivato: ivato.toRoundedUnit(param.precisionexpected, param.roundingtype),
      imposta: imposta.toRoundedUnit(param.precisionexpected, param.roundingtype),
    }
  
}

/**
 * Dato un valore ivato o meno ritorna imponibile, imposta ivato in formato Dinero e 
 * in formato numerico arrotondato a param.precisionexpected
 * 
 * @param {ValorePerValutaConAliquota} param 
 * @returns {ImponibileIvato}
 */
function imponibileivato(param){
  if(typeof param.roundingtype === 'undefined') param.roundingtype = "HALF_UP";
  if(typeof param.precisionexpected === 'undefined') param.precisionexpected = 8;
  if(typeof param.currency === 'undefined') param.currency = "EUR";
  if(typeof param.pivato === 'undefined') param.pivato = false;

  var valorenorm = valuefordinero(param);
  var ivato = 0;
  var imponibile = 0;
  var imposta = 0;
  
  // if(param.pivato){
  //   ivato = valorenorm;
  //   imponibile = scorporaIVA(valorenorm, param.aliquota)
  // } else {
  //   imponibile = valorenorm;
  //   ivato = aggiungiIVA(valorenorm, param.aliquota)
  // }
  // imposta = ivato.subtract(imponibile);  

  if(param.pivato){
    ivato = valorenorm;
    imposta = ivato.multiply(param.aliquota/(100+param.aliquota))
    imponibile = ivato.subtract(imposta);
  } else {
    imponibile = valorenorm;
    imposta = imponibile.percentage(param.aliquota);
    ivato = imponibile.add(imposta);
  }

  return {
    imponibiledin: imponibile,
    ivatodin: ivato,
    impostadin: imposta,
    imponibile: imponibile.toRoundedUnit(param.precisionexpected, param.roundingtype),
    ivato: ivato.toRoundedUnit(param.precisionexpected, param.roundingtype),
    imposta: imposta.toRoundedUnit(param.precisionexpected, param.roundingtype),
  }
 }


module.exports = {
  valuefordinero: valuefordinero, 
  imponibileivato: imponibileivato,
  scorporaIVA: scorporaIVA,
  aggiungiIVA: aggiungiIVA,
}